import { ReactElement } from "react";

import { Modal } from "@/components/General/Modal/modal";
import { ModalType } from "@/redux/modules/value/modal/modal.types";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";
import useMediaQuery from "@/services/breakpoint.hooks";

import { StorePicker } from "./storePicker.container";
import { StorePickerConfig } from "./types/storePickerConfig.type";

type StorePickerModalProps = StorePickerConfig & {
    isOpen: boolean;
    titleTK?: string;
    subTitleTK?: string;
};

export const StorePickerModal = ({
    isOpen,
    titleTK,
    subTitleTK,
    ...storePickerProps
}: StorePickerModalProps): ReactElement => {
    const { t } = useGranite();
    const isSmallScreen = useMediaQuery("screen and (max-height: 530px)");
    const title = t(titleTK || "general.storePicker.modal.title");

    return (
        <Modal
            modalType={ModalType.StorePicker}
            sheetDetent={"default"}
            className={"store-picker-modal"}
            open={isOpen}
            autoFocus={false}
            setOpen={() => storePickerProps.onClose?.()}
            size="sm"
            title={title}
            subtitle={subTitleTK && t(subTitleTK)}
            withFooter={false}
            scrollable={!isSmallScreen}
            centered={!isSmallScreen}
        >
            <StorePicker
                {...storePickerProps}
                disabled={!isOpen}
            />
        </Modal>
    );
};
